import { AUTH_USER, AUTH_USER_EXIST, UNAUTH_USER, LOGOUT_USER, DELETE_ACCOUNT, AUTH_RESET_MESSAGE,
  AUTH_ERROR, FORGOT_PASSWORD_ACCOUNT, RESET_PASSWORD_ACCOUNT } from '../actions/types';

const INITIAL_STATE = { error: '', message: '', authenticated: false, id: null };

export default function (state = INITIAL_STATE, action) {
  switch (action.type) {
    case AUTH_USER:
      var id = null
      if(action.payload && action.payload.user){
        id = action.payload.user._id
      }
      return { ...state, error: '', message: '' , authenticated: true, id: id };
    case AUTH_USER_EXIST:
      return { ...state, error: '', message: 'Cet email est déjà utilisé', authenticated: false, id:null}
    case LOGOUT_USER :
      return {...state, message : '', authenticated: false, id:null}
    case UNAUTH_USER:
      return {...state, message : action.payload, authenticated: false, id:null}
    case DELETE_ACCOUNT:
      return {...state, authenticated: false, message: '', id:null}
    case FORGOT_PASSWORD_ACCOUNT :
      return {...state, message : action.payload.message, id:null}
    case RESET_PASSWORD_ACCOUNT :
      return {...state, message : action.payload.message, id:null}
    case AUTH_RESET_MESSAGE :
      return {...state, message : '', id:null}
    case AUTH_ERROR:
      return {...state, message : '', id:null}
    default:
      return {...state};
  }

}
